import { Capacitor } from '@capacitor/core';

let PushNotifications = null;

export const PushService = {
  async init() {
    if (!Capacitor?.isNativePlatform?.()) return { enabled: false };
    try {
      // Lazy-import so the native plugin isn't touched until we actually need it
      if (!PushNotifications) {
        const mod = await import('@capacitor/push-notifications');
        PushNotifications = mod.PushNotifications;
      }

      // Check if Firebase / Google Services is available before registering.
      // On Android, register() calls FirebaseMessaging.getInstance() which
      // fatally crashes if google-services.json is missing.
      const perm = await PushNotifications.checkPermissions();
      if (perm.receive === 'prompt' || perm.receive === 'granted') {
        const reqResult = await PushNotifications.requestPermissions();
        if (reqResult.receive !== 'granted') {
          return { enabled: false };
        }
      } else {
        return { enabled: false };
      }

      await PushNotifications.register();

      PushNotifications.addListener('registration', token => {
        console.log('[Push] registration token:', token?.value);
      });

      PushNotifications.addListener('registrationError', err => {
        console.warn('[Push] registration error:', err);
      });

      PushNotifications.addListener('pushNotificationReceived', notification => {
        console.log('[Push] received:', notification);
      });

      PushNotifications.addListener('pushNotificationActionPerformed', action => {
        console.log('[Push] action performed:', action);
      });

      return { enabled: true };
    } catch (e) {
      console.warn('[Push] init failed (Firebase likely not configured):', e);
      return { enabled: false, error: e?.message };
    }
  }
};

export default PushService;

